import { render } from "./DisplayTable.vue?vue&type=template&id=d33624b2"
import script from "./DisplayTable.vue?vue&type=script&lang=js"
export * from "./DisplayTable.vue?vue&type=script&lang=js"

import "./DisplayTable.vue?vue&type=style&index=0&id=d33624b2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__